import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

const MONTHLY_COMMISSION_URL: string = '/rest/dashboard/';

@Injectable({
    providedIn: 'root'
})
export class PrlDashboardDataService {

    constructor(private httpClient: HttpClient) {
    }

    public isShowMonthlyCommission(): Observable<Boolean> {
        let url = MONTHLY_COMMISSION_URL + 'show-monthly-commission';
        return this.httpClient.get<boolean>(url);
    }

    public getCurrentEarning():Observable<Number> {
        var url = MONTHLY_COMMISSION_URL + 'current-earning';
        return this.httpClient.get<number>(url);
    }

    public getCalculatedDate():Observable<Date> {
        var url = MONTHLY_COMMISSION_URL + 'calculated-date';
        return this.httpClient.get<Date>(url);
    }

    public getTopZones():Observable<any> {
        var url = MONTHLY_COMMISSION_URL + 'top-zones';
        return this.httpClient.get<any>(url);
    }
}
